import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Icon } from "@iconify/react";
import { useGetAllUserCompanies } from "../../queries/auth";
import { useIsAccountUser } from "../../queries/companyUsers";
import { Box, HStack, VStack } from "../../components/utils";
import OnboardCompanyUploadCard from "./OnboardCompanyUploadCard";

export default function AttachCaptablePage() {
  const navigate = useNavigate();
  const { companyId } = useParams<{ companyId: string }>();
  const { data: companies, isLoading } = useGetAllUserCompanies();

  const { isAccountUser, isLoading: isAccountUserLoading } = useIsAccountUser();
  useEffect(() => {
    if (!isAccountUserLoading && !isAccountUser) navigate("/");
  }, [isAccountUserLoading, isAccountUser, navigate]);

  const company = (companies || []).find((c) => c.uuid === companyId);

  const goBack = () => navigate("/setting/users");

  if (!isAccountUserLoading && !isAccountUser) return null;

  return (
    <div className=" max-w-screen-2xl py-2 px-4 pb-8 mx-auto">
      <VStack className="gap-4">
        <HStack className="items-center">
          <HStack className="items-center">
            <Icon
              icon="mdi:arrow-left"
              height={20}
              className="cursor-pointer text-stone-500 hover:text-stone-700"
              onClick={goBack}
            />
            <p className="text-base font-semibold text-stone-800">
              {company
                ? `Attach Cap Table — ${company.nameOfTheCompany}`
                : "Attach Cap Table"}
            </p>
          </HStack>
        </HStack>

        {isLoading ? (
          <Box className="p-6 text-sm text-stone-500">Loading company…</Box>
        ) : !company ? (
          <Box className="p-6 text-sm text-stone-500">Company not found.</Box>
        ) : (
          <OnboardCompanyUploadCard
            key={company.uuid}
            defaultExpanded
            fullHeight
            companyId={company.uuid}
            initialCompanyDetails={{
              name: company.nameOfTheCompany,
              cin: company.cin,
              jurisdiction: company.jurisdiction,
              companyCurrency: company.companyCurrency,
              valuation: company.valuation,
              sharePrice: company.sharePrice,
            }}
            onOnboarded={goBack}
          />
        )}
      </VStack>
    </div>
  );
}
